export default __webpack_public_path__ + "static/media/image-login.9cb12817.png";